var element = document.documentElement;

/**
 * The [DevJoy](../index.html) module provides functionality for handling full screen API.
 *
 * ## Browser support
 * See: [Element API: `fullscreenchange` event | Can I use](https://caniuse.com/mdn-api_element_fullscreenchange_event)
 *
 * | Browser | Minimum Version |
 * | --- | --- |
 * | Chrome | 71 |
 * | Edge | 79 |
 * | Firefox | 64 |
 * | Internet Explorer | ✗ Not supported |
 * | Opera | 58 |
 * | Safari | 16.4 |
 * 
 * @example
 * // Establish Phoenix Socket and LiveView configuration.
 * import { Socket } from "phoenix";
 * import { LiveSocket } from "phoenix_live_view";
 * import DevJoy from "dev_joy";
 * 
 * let csrfToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");
 * let liveSocket = new LiveSocket("/live", Socket, {
 *   longPollFallbackMs: 2500,
 *   params: { _csrf_token: csrfToken },
 * });
 * 
 * // connect if there are any LiveViews on the page
 * liveSocket.connect();
 * DevJoy.init(liveSocket);
 * 
 * @module DevJoy
 */
export default DevJoy = {
  /**
   * Adds event listeners to support full screen in `DevJoy`-based applications.
   * Those listeners would communicate with the default implementation
   * generated using [`DevJoy.Session.LiveView`](../DevJoy.Session.LiveView.html).
   *
   * @param {Object} liveSocket - The Phoenix LiveView socket instance.
   */
  init: function(liveSocket) {
    addEventListener("phx:dev_joy:fullscreen-toggle", toggleFullscreen);
    element.addEventListener("fullscreenchange", fullscreenchangeHandler.bind(liveSocket));
    fullscreenchangeHandler.bind(liveSocket)();
  },
};

function fullscreenchangeHandler() {
  if (document.fullscreenElement ||
      document.webkitFullscreenElement || /* Opera/Safari */
      document.msFullscreenElement /* IE11 syntax */) {
    this.main.channel.push("dev_joy:fullscreenchange", {fullscreen: true})
  } else {
    this.main.channel.push("dev_joy:fullscreenchange", {fullscreen: false})
  }
}

function toggleFullscreen(event) {
  if (document.fullscreenElement ||
      document.webkitFullscreenElement || /* Opera/Safari */
      document.msFullscreenElement /* IE11 syntax */) {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.webkitExitFullscreen) { /* Safari */
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) { /* IE11 */
      document.msExitFullscreen();
    }
  } else {
    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if (element.webkitRequestFullscreen) { /* Opera/Safari */
      element.webkitRequestFullscreen();
    } else if (element.msRequestFullscreen) { /* IE11 */
      element.msRequestFullscreen();
    }
  }
}